<template>
  <dialog id="create_execute_action" class="modal">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Thực thi tệp tin</h3>

      <div class="py-2">
        <div class="font-medium">Tham số thực thi</div>
        <legend class="fieldset-label mb-2 text-sm wrap-anywhere">
          {{ file_path }}
        </legend>
        <input class="input w-full text-base" v-model="args" />
      </div>

      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn" value="cancel">Hủy</button>
          <!-- value "confirm" sẽ được gán cho dialog.returnValue khi đóng -->
          <button
            class="btn btn-primary"
            value="confirm"
            @click="handle_confirm"
          >
            Xác nhận
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { use_explorer } from "./useExplorer";

const props = defineProps<{
  file_path?: string;
}>();
const args = ref<string>();
const explorer_store = use_explorer();

const handle_confirm = async () => {
  if (!props.file_path) return;
  explorer_store.handle_execute(props.file_path, args.value);
};
</script>
